<template>
  <q-table
    :columns="cols"
    :rows="rows"
    class="external-dns-table"
    :class="{ empty: rows.length === 0 }"
    ref="blueprintsTable"
    row-key="id"
    flat
    v-model:pagination="pagination"
    :loading="loading"
    binary-state-sort
    :rows-per-page-options="perPageOptions"
    @request="load"
  >
    <template v-slot:no-data>
      <div class="flex full-width column items-center q-py-lg">
        <q-icon name="mdi-cloud-search" class="q-mb-sm" size="40px" color="primary"></q-icon>
        <span class="block" style="font-size: 14px">No items were found.</span>
      </div>
    </template>
    <template v-slot:body-cell-id="props">
      <q-td :props="props" align="left">
        <span class="flex items-center"
          ><q-icon v-if="props.row.deletedAt" size="18px" color="grey" name="close"></q-icon>{{ props.row.id }}</span
        >
      </q-td>
    </template>
    <template v-slot:body-cell-actions="props">
      <q-td :props="props" align="right">
        <WorkflowsBtn
          @showWorkflow="showWorkflow($event, props.row)"
          :loading="loading"
          :relatedWorkflowStatuses="relatedWorkflowStatuses.find((item) => item.uuid === props.row.uuid)?.statuses"
        />
        <q-btn
          flat
          round
          size="9px"
          style="width: 30px; height: 40px"
          class="btn--no-hover"
          :ripple="false"
          icon="engp:engp-ico-copy"
          @click.stop="copyId(props.row.uuid)"
        >
          <q-tooltip>Copy UUID</q-tooltip>
        </q-btn>
        <q-btn
          v-if="!props.row.deletedAt"
          flat
          round
          size="12px"
          icon="sym_r_edit"
          style="width: 30px; height: 40px"
          class="btn--no-hover"
          :loading="loading"
          @click="$router.push(`/blueprints/${encodeURIComponent(props.row.uuid)}`)"
        >
          <!-- <q-tooltip v-if="!loading" max-width="480px" style="white-space: pre-line">{{
            !!!!  :disabled="loading || disableEditIds.find((item) => item.id === props.row.id)"
            !!disableEditIds.find((item) => item.id === props.row.id)
              ? disableEditIds.find((item) => item.id === props.row.id)?.message
              : 'Edit'
          }}</q-tooltip> -->
          <q-tooltip>Edit</q-tooltip>
        </q-btn>
        <q-btn
          v-if="!props.row.deletedAt"
          flat
          round
          size="12px"
          @click="$emit('confirmDeleteBlueprint', props.row)"
          :loading="loading"
          :disabled="loading || disableDeleteIds.find((item) => item.id === props.row.id)"
          icon="sym_r_delete"
          style="width: 30px; height: 40px"
          class="btn--no-hover"
        >
          <q-tooltip max-width="480px" style="white-space: pre-line" v-if="!loading">{{
            disableDeleteIds.find((item) => item.id === props.row.id)
              ? disableDeleteIds.find((item) => item.id === props.row.id).message
              : 'Delete'
          }}</q-tooltip>
        </q-btn>
      </q-td>
    </template>
  </q-table>
</template>

<script>
import { copyToClipboard } from 'quasar';
import { supportCntrlClick } from '@/shared/helpers';
import dayjs from 'dayjs';
import { getBlueprints } from '../api/api';
import WorkflowsBtn from '@/shared/components/WorkflowsBtn.vue';
import { validateWorkFlow, getRelatedWorkflowsStatuses } from '@/pages/registrations/api/api';

export default {
  name: 'BlueprintsTable',
  components: {
    WorkflowsBtn,
  },
  props: {
    rowsPerPageOptions: {
      type: Array,
      default: () => [5, 7, 10, 15, 20],
    },
    filters: {
      type: Object,
    },
  },
  data() {
    return {
      perPageOptions: this.rowsPerPageOptions,
      rows: [],
      cols: [
        { name: 'id', label: 'ID', field: 'id', align: 'left', sortable: true },
        {
          name: 'bpmnProcessId',
          field: 'bpmnProcessId',
          label: 'BPMN process ID',
          align: 'left',
          sortable: false,
        },
        {
          label: 'Created at',
          name: 'createdAt',
          field: 'createdAt',
          align: 'left',
          format: (val) => dayjs(val).format('DD.MM.YYYY HH:mm'),
          sortable: true,
        },
        {
          label: 'Updated at',
          name: 'updatedAt',
          field: 'updatedAt',
          align: 'left',
          format: (val) => dayjs(val).format('DD.MM.YYYY HH:mm'),
          sortable: true,
        },
        {
          label: '',
          name: 'actions',
          field: 'actions',
          align: 'right',
        },
      ],
      pagination: {
        sortBy: 'updatedAt',
        descending: true,
        page: 1,
        rowsPerPage: 20,
      },
      loading: false,
      disableDeleteIds: [],
      disableEditIds: [],
      relatedWorkflowStatuses: [],
    };
  },
  methods: {
    copyId(id) {
      copyToClipboard(id).then(() => {
        this.$notify('info', 'Info', 'Blueprint UUID was copied');
      });
    },
    showWorkflow(event, data) {
      supportCntrlClick(event, `/workflows?itemId=${data.uuid}`);
    },
    async load(props) {
      this.loading = true;
      try {
        this.relatedWorkflowStatuses = [];
        const { sortBy, descending, page, rowsPerPage } = props.pagination;
        const skip = page === 1 ? 0 : (page - 1) * rowsPerPage;
        const { count, data } = await getBlueprints(
          rowsPerPage,
          skip,
          sortBy,
          descending,
          this.filters.dateFrom,
          this.filters.dateTo,
          this.filters.id,
          this.filters.uuid,
          this.filters.inputVariablesSchema,
          this.filters.authorizationSchema,
          this.filters.subSchemas,
          this.filters.deleted,
        );
        this.rows = data;
        this.pagination = { ...props.pagination, rowsNumber: count };
        this.$router.replace({ query: this.buildQueryFromFilters() });

        const deletePrevalPromises = this.rows.map(async (item) => {
          const data = {
            workflowId: 'engprt.delete-blueprint',
            inputVariables: {
              uuid: item.uuid,
            },
          };
          return validateWorkFlow(data).catch((res) => {
            this.disableDeleteIds.push({ id: item.id, message: res.message });
          });
        });

        // const editPrevalPromises = this.rows.map(async (item) => {
        //   const data = {
        //     workflowId: 'engprt.update-blueprint',
        //     inputVariables: {
        //       uuid: item.uuid,
        //     },
        //   };
        //   return validateWorkFlow(data).catch((res) => {
        //     this.disableEditIds.push({ id: item.id, message: res.message });
        //   });
        // });
        const relatedWorkflowsPrmises = this.rows.map((record) => {
          return getRelatedWorkflowsStatuses(record.uuid).then((response) => {
            this.relatedWorkflowStatuses.push({ uuid: record.uuid, statuses: response });
          });
        });
        await Promise.all([...deletePrevalPromises, ...relatedWorkflowsPrmises]);
      } catch (err) {
        this.$notify('negative', 'Error', err.message);
      } finally {
        this.loading = false;
      }
    },
    buildQueryFromFilters() {
      const query = {};
      for (const key in this.filters) {
        if (this.filters[key] !== undefined && this.filters[key] !== null && this.filters[key] !== '') {
          query[key] = String(this.filters[key]);
        }
      }
      if (this.pagination.sortBy) {
        query.sortBy = this.pagination.sortBy;
        query.descending = String(this.pagination.descending);
      }
      query.page = String(this.pagination.page);
      query.rowsPerPage = String(this.pagination.rowsPerPage);
      return query;
    },
    reload() {
      this.$refs.blueprintsTable.requestServerInteraction();
    },
  },
  mounted() {
    const query = this.$route.query;
    if (query.sortBy) this.pagination.sortBy = query.sortBy;
    if (query.descending) this.pagination.descending = query.descending === 'true';
    if (query.page) this.pagination.page = Number(query.page);
    if (query.rowsPerPage) this.pagination.rowsPerPage = Number(query.rowsPerPage);
  },
};
</script>
